/**
 * The desktop shell's bridge — `ts/apps/desktop`'s preload, absent in a browser.
 *
 * The shell loads this site as it is (docs/plans/desktop-electron.md), so the
 * page cannot assume it is inside one: everything here is optional, and a
 * caller does nothing when the bridge is missing.
 *
 * Its one job today: the tab row is the window's title bar in the desktop app,
 * and Windows draws ─ □ ✕ over its right end in colours the shell has to be
 * told, because the theme is the workspace's rather than the OS's.
 */

export interface DesktopBridge {
  /** Repaint the window buttons: the bar's background, and their glyphs. */
  setTitleBarColors(color: string, symbolColor: string): void;
  /**
   * The pop-outs this window had open when the app last quit, by window name
   * (`DATA_WINDOW_NAME`). The shell keeps the list because the page cannot:
   * quitting closes the pop-out, and a closing pop-out is the panel coming home.
   * Optional, so a page newer than the installed shell still loads.
   */
  restoredWindows?(): Promise<string[]>;
}

export function desktopBridge(): DesktopBridge | undefined {
  return (globalThis as { qfDesktop?: DesktopBridge }).qfDesktop;
}
